import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { RequestMethod } from '@api/abstracts/models';
import { MockService } from '@api/mock';
import { LogsService } from '@shared/services/logs';
import { PlatformContextService } from '@shared/services/platform-context';
import { Observable } from 'rxjs';

@Injectable()
export class MockInterceptor implements HttpInterceptor {
  private readonly mockService = inject(MockService);
  private readonly platformContextService = inject(PlatformContextService);
  private readonly logs = inject(LogsService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.mockService.isActivated) {
      const method: keyof typeof RequestMethod = req.method as keyof typeof RequestMethod;
      const response = this.mockService.getMockResponse(method, req.urlWithParams, () => next.handle(req));
      if (response) {
        if (this.platformContextService.isBrowser())
          this.logs.debug('MockInterceptor', `[MOCK] ${req.method} ${req.url}`, { muted: true });
        return response;
      }

      return next.handle(req);
    } else {
      return next.handle(req);
    }
  }
}
